export default __webpack_public_path__ + "static/media/Leggings of Untamed Violence.ed56a8f7.jpg";